export type PartnerType = {
  mechanicId: number;
  name: string;
  logoSrc: string;
  slug: string;
  override: { heroSrc: string };
};

export type PartnerPromotionalBannerProperties = {
  bannerEnabled: boolean;
  title?: string;
  description?: string;
  backgroundColor?: string;
  terms?: string;
  ctaUrl?: string;
  titleColour?: string;
  descriptionColour?: string;
  termsColour?: string;
  collectionMethod?: COLLECTION_METHOD_PDP | null;
};

export type PartnerPromotionalBannerResponse = {
  pagePartnerCollection: {
    items: Array<{
      partnerPromotionalBannerCollection: {
        items: PromotionalBannerProperties[];
      };
    }>;
  };
};

export type PromotionalBannerProperties = {
  title?: string;
  description?: string;
  terms?: string;
  termsUrl?: string;
  backgroundColour?: string;
  titleColour?: string;
  descriptionColour?: string;
  termsColour?: string;
  includedPartners?: PartnerType[];
  excludedPartners?: PartnerType[];
  includedCategories?: string[];
  collectionMethod?: COLLECTION_METHOD_PDP;
} | null;

export enum COLLECTION_METHOD_PDP {
  Online = 'Online',
  InStore = 'InStore',
  Manual = 'Manual',
  Any = 'Any',
}
